import { ArrowDownSvg, ArrowTopSvg } from "~/ui-rtk/components/ui/svg/arrow"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

interface DeltaCellProps {
  /** Already-formatted current-window value (e.g. "$1,234", "3", "2.31x") */
  value: string
  /** Delta vs the prior 7-day window; null renders as "--" */
  delta: number | null
  /** "percent" → 12.3%, "pp" → 4.2pp, "count" → 3 */
  format?: "percent" | "pp" | "count"
  /** Which delta direction renders green (default "up") */
  goodDirection?: "up" | "down"
}

export default function DeltaCell({
  value,
  delta,
  format = "percent",
  goodDirection = "up",
}: DeltaCellProps) {
  const isUp = delta !== null && delta > 0
  const isGood = goodDirection === "up" ? isUp : !isUp
  const deltaText =
    delta === null
      ? null
      : format === "percent"
        ? `${Math.abs(delta).toFixed(1)}%`
        : format === "pp"
          ? `${Math.abs(delta).toFixed(1)}pp`
          : `${Math.abs(Math.round(delta))}`

  return (
    <div className="flex flex-col items-end">
      <span className="text-sm">{value}</span>
      {delta === null ? (
        <span className="text-xs text-gray-500">--</span>
      ) : delta === 0 ? (
        <span className="text-xs text-gray-500">{deltaText}</span>
      ) : (
        <span
          className={cn(
            "text-xs font-medium flex items-center gap-0.5",
            isGood ? "text-american-green" : "text-states-error",
          )}
        >
          {isUp ? <ArrowTopSvg size={10} /> : <ArrowDownSvg size={10} />}
          {deltaText}
        </span>
      )}
    </div>
  )
}
